<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ProgressSteps from "@/components/website/ProgressSteps.vue";
import WebsiteCard from "@/components/website/WebsiteCard.vue";
import {computed, onMounted} from "vue";
import {useStore} from "vuex";

const emit = defineEmits(['back']);
const store = useStore();

const agencyProduct = computed(() => store.getters['agencyWebsite/agencyProduct']);
const localProduct = computed(() => store.getters['agencyWebsite/localProduct']);

onMounted(async () => {
  if (Object.keys(store.getters['agencyWebsite/agencyProduct']).length === 0) {
    await store.dispatch('agencyWebsite/fetchProducts');
  }
});

const handleBack = () => {
  store.dispatch('agencyWebsite/setErrors', {});

  emit('back');
}
</script>

<template>
  <div
    class="tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-xl tw-text-center tw-max-w-default-container tw-mx-auto tw-py-6 tw-min-h-[680px]"
  >
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-6 tw-gap-8 tw-max-w-[760px] tw-w-3/4">
      <div class="md:tw-flex-row tw-flex tw-flex-col tw-gap-6 tw-justify-between tw-w-full">
        <WebsiteCard
          :key="localProduct.id"
          :product="localProduct"
          :alternate-has-discount="!! agencyProduct.discountPrice"
          description="Choose this if you would like to manage your clients Google Business Profile listing only."
          :inclusions="[
            {
              ticked: true,
              description: 'Manage your Google Business Profile listing',
            },
            {
              ticked: false,
              description: 'Manage your website\'s SEO',
            },
          ]"
        />

        <WebsiteCard
          :key="agencyProduct.id"
          :product="agencyProduct"
          :alternate-has-discount="!! localProduct.discountPrice"
          class="!tw-border-blue"
          description="Choose this if you would like to SEO your clients’s website and Google Business Profile listing."
          :inclusions="[
            {
              ticked: true,
              description: 'Manage your Google Business Profile listing',
            },
            {
              ticked: true,
              description: 'Manage your website\'s SEO',
            },
          ]"
        />
      </div>

      <div class="tw-flex tw-w-full">
        <DefaultButton
          variant="base"
          @click="handleBack"
        >
          Back
        </DefaultButton>
      </div>

      <div class="tw-flex tw-flex-col">
        <ProgressSteps :current-step="3" />
      </div>
    </div>
  </div>
</template>
